import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-app" }


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import { useProgramStore } from './stores/programStore';
// const storeData = useProgramStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <p>Pinia Store: {{ storeData }}</p> "),
    _createVNode(_component_router_view)
  ]))
}
}

})